import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ReplayViewerAnalysisComponent } from "./replay-viewer-analysis.component";
import { BaseChartDirective } from 'ng2-charts';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    BaseChartDirective
  ],
  exports: [ReplayViewerAnalysisComponent],
  declarations: [ReplayViewerAnalysisComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ReplayViewerAnalysisComponentModule {}
